/* * @Author: 曹俊杰 * @Date: 2022-04-28 19:39:02 * @Module: 二维码弹出框 */
<template>
  <div class="qrDialog">
    <el-dialog
      destroy-on-close
      :visible.sync="dialogVisible"
      @close="close"
      custom-class="content"
      :close-on-click-modal="false"
    >
      <div class="title">{{ title }}</div>

      <slot name="desc"></slot>
      <div class="name" v-if="name && id">{{ name }}（{{ id }}）</div>
      <vue-qr :text="url" :margin="0" :size="160" style="margin: 0 auto"></vue-qr>
      <slot :url="url"></slot>
    </el-dialog>
  </div>
</template>
<script>
import vueQr from "vue-qr";
export default {
  components: { vueQr },
  props: {
    title: {
      type: String,
      default: "扫码认证",
    },
  },
  data() {
    return {
      dialogVisible: false,
      url: "",
      name: "",
      id: "",
      desc: "请使用微信扫描二维码进行认证",
    };
  },
  mounted() {},
  methods: {
    show(url, name, id) {
      name && (this.name = name);
      id && (this.id = id);
      this.url = url;
      this.dialogVisible = true;
    },
    hidden() {
      this.url = "";
      this.dialogVisible = false;
    },
    close() {
      this.$emit("close");
    },
  },
};
</script>
<style lang="scss" scoped>
.title {
  height: 58px;
  font-size: 18px;
  font-weight: 500;
  line-height: 26px;

  color: #262626;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fafafa;
}
.qrDialog {
  &::v-deep .el-dialog__header {
    padding: 0;
  }
  &::v-deep .el-dialog__body {
    display: flex;
    flex-direction: column;
    text-align: center;
    padding-bottom: 22px;
    .name {
      height: 52px;
      display: flex;
      align-items: center;
      justify-content: center;

      font-size: 14px;
      color: #666666;
    }
    .text {
      color: #666666;
      margin-top: 16px;
      span:nth-child(2) {
        color: #0062ff;
      }
    }
  }
}
</style>
